import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CentralCatalogueService } from '../../../services/central-catalogue/central-catalogue.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// add or edit a guest house / dormitory building (accommodation set). self-saving.
@Component({
  selector: 'app-cc-set-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoaderComponent],
  templateUrl: './cc-set-dialog.component.html',
  styleUrls: ['../cc-dialog-form.scss', '../../../../common-style/ac-dialog.scss'],
})
export class CcSetDialogComponent {
  form: FormGroup;
  isLoading: boolean = false;
  isEdit: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CcSetDialogComponent>,
    private catalogueService: CentralCatalogueService,
    private toastService: ToastService,
    @Inject(MAT_DIALOG_DATA) public data: { set?: any; premisesList: any[] }
  ) {
    const row = this.data?.set;
    this.isEdit = !!row;
    this.form = this.fb.group({
      premisesId: [row?.premisesId || '', Validators.required],
      type: [row?.type || 'INTERNAL', Validators.required],
      name: [row?.name || '', Validators.required],
      abbrevName: [row?.abbrevName || '', Validators.required],
      address: [row?.address || '', Validators.required],
      category: [row?.category || '', Validators.required],
      floorCount: [row?.floorCount ?? '', Validators.required],
      contactNumber: [row?.contactNumber || '', Validators.required],
      altContactNumber: [row?.altContactNumber || ''],
      status: [row?.status || 'ACTIVE', Validators.required],
      totalCapacity: [row?.totalCapacity ?? ''],
      gstNumber: [row?.gstNumber || ''],
      isUtsav: [row?.isUtsav === true],
      comments: [row?.comments || ''],
    });
  }

  get title(): string {
    return this.isEdit ? 'Edit guest house' : 'Add guest house';
  }

  submit(): void {
    if (this.form.invalid) {
      this.toastService.error(
        'Premises, type, name, short name, address, category, floors and contact are required.'
      );
      return;
    }
    this.isLoading = true;
    // status changes go through the Activate/Deactivate flow (which records a
    // reason); an edit keeps the stored status untouched.
    const payload = this.isEdit
      ? { ...this.form.value, status: this.data.set.status }
      : this.form.value;
    const request = this.isEdit
      ? this.catalogueService.updateSet(this.data.set.setId, payload)
      : this.catalogueService.addSet(payload);

    request.subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Saved.');
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to save the guest house.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
